import { map } from 'lodash/fp';
import { RestrictionType } from '@mews-commander/data-access';
import { Day } from '@mews/enums';

export const ASIDE_WIDTH = 376;
export const CELL_HEIGHT = 88;
export const CELL_WIDTH = 194;
export const HEADER_HEIGHT = 48;
export const BODY_CELL_DEFAULT_HEIGHT = 56;

export const BORDER_THICKNESS = 1;

export const SIZE_PER_EXCEPTION = 36;
export const OPEN_HOURS_INTERVAL_HEIGHT = 18;
export const EXCEPTION_OPEN_INTERVAL_HEIGHT = 18;
export const EXCEPTION_OPEN_INTERVAL_DIVIDER_HEIGHT = 1;
export const MAX_ASIDE_CELL_NAME_LENGTH = 16;
export const ADVANCE_EXCEPTION_TYPE = 'advance';
export const LENGTH_EXCEPTION_TYPE = 'length';
export const PRICE_EXCEPTION_TYPE = 'price';
export const RESERVATION_COUNT_EXCEPTION_TYPE = 'reservationCount';
export const SECONDARY_TIME_UNIT_LENGTH = 'secondaryRange';

export const RESTRICTION_TYPE_LABEL_MAP = {
    [RestrictionType.ClosedToArrival]: 'CTA',
    [RestrictionType.ClosedToDeparture]: 'CTD',
    [RestrictionType.ClosedToStay]: 'CTS',
};

export const RESTRICTIONS_FILTERS_FORM_NAME = 'restrictionsFilterForm';

export const INITIAL_NEW_RESTRICTION_FORM_VALUES = {
    type: RestrictionType.ClosedToStay,
};

export const INITIAL_NEW_RESTRICTION_FORM_DAY_VALUES = {
    days: map('name', Day.enumValues),
    type: RestrictionType.ClosedToStay,
};

export const FORM_DATA_REFETCH_PERIOD = 10 * 60 * 1000;

export const BODY_CELL_EVENT_CATEGORY = 'RestrictionsBodyCell';
export const DETAIL_FORM_EVENT_CATEGORY = 'RestrictionDetailForm';
export const FILTER_EVENT_CATEGORY = 'RestrictionsFilter';
export const SIDEBAR_EVENT_CATEGORY = 'RestrictionsSidebar';
